var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgeriesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EBF6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H9.5V11.5C9.5 11.3674 9.44732 11.2402 9.35355 11.1464C9.25979 11.0527 9.13261 11 9 11C8.86739 11 8.74021 11.0527 8.64645 11.1464C8.55268 11.2402 8.5 11.3674 8.5 11.5V21.5C8.5 21.6326 8.55268 21.7598 8.64645 21.8536C8.74021 21.9473 8.86739 22 9 22C9.13261 22 9.25979 21.9473 9.35355 21.8536C9.44732 21.7598 9.5 21.6326 9.5 21.5V19.5H22.5V21.5C22.5 21.6326 22.5527 21.7598 22.6464 21.8536C22.7402 21.9473 22.8674 22 23 22C23.1326 22 23.2598 21.9473 23.3536 21.8536C23.4473 21.7598 23.5 21.6326 23.5 21.5V15.5C23.5 14.837 23.2366 14.2011 22.7678 13.7322C22.2989 13.2634 21.663 13 21 13ZM9.5 14H14V18.5H9.5V14ZM15 18.5V14H21C21.3978 14 21.7794 14.158 22.0607 14.4393C22.342 14.7206 22.5 15.1022 22.5 15.5V18.5H15Z",
    fill: "#36A1C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgeriesSolid);
export default __webpack_public_path__ + "static/media/surgeries-solid.4abc27de7bef08be36514414fa38c75d.svg";
export { ForwardRef as ReactComponent };